/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Person from "@material-ui/icons/Person";
import AccountBalanceIcon from "@material-ui/icons/AccountBalance";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Grid } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import DropDown from "./DropDown";
import brandTheme from "brandTheme/Theme";
import ToastModal from "views/components/ToastModal";

const useStyles = makeStyles(() => ({
  headerContainer: {
    display: "flex",
    alignItems: "center",
    height: "76px",
    padding: "0 20px",
  },

  rightSection: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    width: "100%",
    gap: "15px",
  },

  headerItem: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "110px",
  },

  iconRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "4px",
    height: "26px",
  },

  itemIcon: {
    fontSize: "22px",
  },

  arrowIcon: {
    fontSize: "18px",
    marginTop: "2px",
  },

  itemText: {
    fontSize: "12px",
    textAlign: "center",
    fontWeight: 400,
    color: "#333",
    marginTop: "0px",
    lineHeight: "14px",
  },
}));

const DesktopHeader = ({ userDetailData }) => {
  const classes = useStyles();
  const [openProfile, setOpenProfile] = React.useState(null);

  const [moduleData, setModuleData] = useState({});
  const { authToken } = useSelector((state) => state.login.authData);
  const { email } = useSelector((state) => state.login.userData);

  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");

  const navigateToLoginPage = async () => {
    const result = await apiHandler({
      url: endpoint.APP_URL,
      authToken: authToken,
    });

    if (result.data?.main) window.location.href = result.data.main;
  };

  useEffect(() => {
    const storageChange = (event) => {
      if (event.key === "persist:root") {
        const { login } = JSON.parse(event.newValue);
        const { authData } = JSON.parse(login);
        if (!authData?.isAuthenticated) navigateToLoginPage();
      }
    };

    window.addEventListener("storage", storageChange);
    return () => window.removeEventListener("storage", storageChange);
  }, []);

  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };

  const handleCloseProfile = () => setOpenProfile(null);

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };

  useEffect(() => {
    if (authToken) getOtherAppsUrl();
  }, [authToken]);

  const openModule = async (module) => {
    const result = await apiHandler({
      url: endpoint.RETAIN_TOKEN,
      method: "POST",
      authToken,
      data: { username: email, accessToken: authToken },
    });

    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.error_description, true);
    } else {
      const URL = moduleData[module] + "/auto/" + result.data.uuid;
      window.open(URL, "_self");
    }
  };

  const getOtherAppsUrl = async () => {
    const result = await apiHandler({ url: endpoint.APP_URL });
    setModuleData(result.data);
  };

  const handleExitToSSO = () => openModule("main");

  const formatDate = () => {
    const d = new Date();
    const day = ("0" + d.getDate()).slice(-2);
    const year = d.getFullYear();
    const month = d.toLocaleString("default", { month: "long" });
    return `${day}-${month}-${year}`;
  };

  return (
    <Grid container className={classes.headerContainer}>
      {/* RIGHT SECTION ICONS */}
      <Grid item xs={12} className={classes.rightSection}>
        
        {/* DATE BLOCK */}
        <div className={classes.headerItem}>
          <div className={classes.iconRow}>
            <CalendarTodayIcon className={classes.itemIcon} />
          </div>
          <span className={classes.itemText}>{formatDate()}</span>
        </div>

        {/* BRANCH BLOCK */}
        <div className={classes.headerItem}>
          <div className={classes.iconRow}>
            <AccountBalanceIcon className={classes.itemIcon} />
          </div>
          <span className={classes.itemText}>
            {userDetailData?.branchName || "New Delhi"}
          </span>
        </div>

        {/* PROFILE BLOCK */}
        <div className={classes.headerItem} onClick={handleClickProfile}>
          <div className={classes.iconRow}>
            <Person className={classes.itemIcon} />
            {openProfile ? (
              <KeyboardArrowUpIcon className={classes.arrowIcon} />
            ) : (
              <KeyboardArrowDownIcon className={classes.arrowIcon} />
            )}
          </div>
          <span className={classes.itemText}>{userDetailData?.name}</span>
        </div>

      </Grid>

      {/* PROFILE DROPDOWN */}
      <DropDown
        navigateToLoginPage={navigateToLoginPage}
        handleCloseProfile={handleCloseProfile}
        openProfile={openProfile}
        handleExitToSSO={handleExitToSSO}
      />

      {/* TOAST */}
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
    </Grid>
  );
};

DesktopHeader.propTypes = {
  classes: PropTypes.object,
};

export default DesktopHeader;
